export interface FAQItem {
  question: string;
  answer: string;
}

export const faqs: FAQItem[] = [
  {
    question: '如何报名参加一起草每日大赛？',
    answer: '您可以通过我们的官方网站或官方小程序进行报名。进入"赛事报名"页面，选择您要参加的比赛日期和项目，填写个人信息并完成支付即可。报名成功后，您将收到确认短信和邮件通知。每场比赛开始前24小时截止报名，建议尽早报名以确保参赛名额。',
  },
  {
    question: '参加比赛需要什么条件？',
    answer: '参加一起草每日大赛的基本条件包括：年满16周岁、身体健康、无严重心血管疾病等不适合剧烈运动的健康状况。部分高级别赛事可能对参赛者有一定积分或段位要求。首次参赛的选手需要完成实名认证和健康声明签署。',
  },
  {
    question: '比赛奖励如何发放？',
    answer: '奖金将在比赛结束后3个工作日内通过银行转账发放至您绑定的账户。实物奖品将在7个工作日内通过快递寄出。积分奖励实时到账，可立即在排行榜和个人中心查看。请确保您的账户信息和收货地址准确无误。',
  },
  {
    question: '如果当天无法参加已报名的比赛，可以退款吗？',
    answer: '在比赛开始前48小时以上取消报名，可全额退款。24-48小时内取消，退还50%报名费。不足24小时取消，恕不退款。您也可以选择将报名资格转移至后续场次（限一次），请在比赛开始前联系客服处理。',
  },
  {
    question: '如何查看我的排名和历史成绩？',
    answer: '登录您的账户后，进入"个人中心"即可查看完整的参赛历史记录、当前排名和积分详情。排名数据每周日凌晨更新。您还可以在"数据统计"页面查看详细的竞技数据分析和趋势图表。',
  },
  {
    question: '比赛场地在哪里？如何到达？',
    answer: '一起草每日大赛在全国32个主要城市均设有标准比赛场地。报名时系统会自动为您推荐最近的分赛区。您也可以在"场地信息"页面查看各赛区的详细地址、交通指南和场地设施介绍。部分城市提供赛区接驳车服务。',
  },
  {
    question: '可以以团队形式参赛吗？',
    answer: '可以的！我们设有个人赛和团队赛两种模式。团队赛支持2-4人组队参加。团队报名时需要由队长创建队伍，队员通过邀请码加入。团队赛有独立的积分系统和排行榜，团队排名根据队员总积分计算。',
  },
  {
    question: '新人应该如何开始？',
    answer: '我们强烈建议新人先从"新人入门"分类的赛事开始参与。您可以先浏览我们网站上的新人入门文章和教程视频，了解基本规则和技巧。此外，我们每月举办"新手体验日"活动，由专业教练现场指导，非常适合零基础选手参加。',
  },
];